import React, { Component } from 'react';
import { Grid, Pagination } from 'semantic-ui-react';
import DataGrid from '../shared/DataGrid';
class BaseTab extends Component {

    handleOptionChange = (option, value) => {
        const { summary } = this.props.data;
        const data = [...summary.data];

        data.forEach((row, rowIndex) => {
            row.cellData.forEach((cell, cellIndex) => {
                if (cell.data.code === option.code) {
                    data[rowIndex].cellData[cellIndex] = {...data[rowIndex].cellData[cellIndex], data: {...option} }
                }
            })
        })

        this.props.onOptionChange({ ...summary, data })
    }

    render() {
        const { props } = this;
        
        const tablet = 8;
        const computer = 8;
        const largeScreen = 5;
        const wideScreen = 4;

        return (
            <Grid className="height-100 gs-flex-container-vertical">
                <Grid.Row className="flex-stretch">
                    {(props.showSummary) &&
                        <Grid.Column computer={computer} tablet={tablet} largeScreen={largeScreen} widescreen={wideScreen} className="gs-flex-container-vertical">
                            <DataGrid
                                loading={props.loading}
                                headings={props.data.summary.headerDef}
                                data={props.data.summary.data}
                                rowDef={props.data.summary.rowDef}
                                disableSort={true}
                                fullHeight
                                disableActiveRow={true}
                                onOptionChange={this.handleOptionChange}
                            />
                        </Grid.Column>
                    }
                    <Grid.Column computer={props.showSummary ? 16 - computer : "16"} tablet={props.showSummary ? 16 - tablet : "16"} largeScreen={props.showSummary ? 16 - largeScreen : "16"} widescreen={props.showSummary ? 16 - wideScreen : "16"} className="gs-flex-container-vertical">
                        <DataGrid
                            loading={props.loading}
                            headings={props.data.grid.headerDef}
                            data={props.data.grid.data}
                            onRowClick={props.onRowClick}
                            rowDef={props.data.grid.rowDef}
                            fullHeight
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width="16" textAlign="right">
                        <Pagination size="mini" defaultActivePage={props.data.grid.pageNumber} totalPages={props.data.grid.pageCount} onPageChange={this.onPageChange} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default BaseTab;